export const GRID_DND_SIDEBAR_SELLABLE_ITEM = 'GRID_DND_SIDEBAR_SELLABLE_ITEM'

export const GRID_SELLABLE_ITEM_COLORS = [
  '#66C5E3',
  '#796097',
  '#E4523B',
  '#FDB339',
  '#22A57C',
  '#F87288',
]



/** WEBPACK FOOTER **
 ** ./src/constants/grid-constants.js
 **/